import ApiService from 'services/ApiService';

export interface ApplicationModel {
        id: number;
        partner: string;
        ipaddress: string;
}

class ApplicationService extends ApiService<ApplicationModel> {
        constructor() {
                super('application');
        }
}

export default new ApplicationService();
